import Icon from "@ant-design/icons";

import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;
const CheckAllSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="m4.261 13.49l6.614-10.822l-1.707-1.043l-5.43 8.885l-2.394-1.916l-1.25 1.562zM16 3h-4v2h4zm0 4h-6v2h6zm0 4v2H8v-2z"
    />
  </svg>
);
const CheckAllIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CheckAllSvg} {...props} />
);
export default CheckAllIcon;
